export default __webpack_public_path__ + "static/media/veggie_plate.15d2a19c.jpg";